var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCloseMobile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  fillRule: "evenodd",
  d: "M7.031 5.97a.75.75 0 1 0-1.06 1.06L10.94 12l-4.97 4.97a.75.75 0 0 0 1.06 1.06L12 13.06l4.97 4.97a.75.75 0 0 0 1.06-1.06L13.06 12l4.97-4.97a.75.75 0 1 0-1.06-1.06L12 10.939z",
  clipRule: "evenodd"
})));
export default SvgCloseMobile;